export default function ProblemsSection() {
  const problems = [
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Problems-with-using-unstable-solutions-developed.png',
      title: '개인이나 소규모 업체가 개발한 불안정한 솔루션'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/High-labor-costs-that-prevent-proper-operation.png',
      title: '높은 인건비 등 부담스러운 운영 비용'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Problems-with-using-an-out-of-the-box-solution.png',
      title: '획일화 된 사이트 디자인'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/landing_promotion.png',
      title: '부족한 프로모션 지원 프로그램'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/landing_bankaccount.png',
      title: '한국시장 특성상 발생하는 은행 계좌 문제'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/landing_fakecasinovideo.png',
      title: '가짜 카지노 영상을 사용해 발생하는 사기 문제'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">우리는 문제를 알고 있습니다</h2>
          <p className="text-xl text-gray-600">온라인 배팅 사이트 운영은 쉽지 않습니다</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-fade-in-up border border-gray-100"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-32 h-32 mb-6 flex items-center justify-center">
                  <img 
                    src={problem.icon} 
                    alt={problem.title}
                    className="w-full h-full object-contain"
                  />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 leading-snug">
                  {problem.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
